import React, { useEffect, useState } from 'react';
import './PopupsPage.css';

import past1 from '../assets/about-14.jpg';
import past2 from '../assets/about-22.jpg';
import past3 from '../assets/about-23jpg.jpg';
import past4 from '../assets/about-24.jpg';
import past5 from '../assets/about-25.jpg';
import past6 from '../assets/about-26.jpg';

import macha2 from '../assets/Nov-Thompson/macha2.avif';
import girlSweater from '../assets/Nov-Thompson/girl-sweater.avif';
import ceramic from '../assets/Nov-Thompson/ceramic.avif';
import syrup from '../assets/Nov-Thompson/syrup.avif';
import desertLady from '../assets/Nov-Thompson/Desert-Lady.avif';
import softToy from '../assets/Nov-Thompson/Soft-toy.avif';
import chains from '../assets/Nov-Thompson/chains.avif';
import heartPainting from '../assets/Nov-Thompson/heart-painting.avif';


import Belaris from '../assets/Arta-April/Belaris.avif';
import Coffee from '../assets/Arta-April/Coffee.avif';
import Jewelry from '../assets/Arta-April/Jewelry.avif';
import Labgrown from '../assets/Arta-April/Lab-grown.avif';
import Perfume from '../assets/Arta-April/Perfume.avif';
import Wood from '../assets/Arta-April/Wood-Works.avif';

const slides1 = [past1, past2, past3];
const slides2 = [past4, past5, past6];

const slides5 = [macha2, girlSweater, ceramic, syrup];
const slides6 = [desertLady, softToy, chains, heartPainting];

const slides7 = [Belaris, Coffee, Jewelry];
const slides8 = [Labgrown, Perfume, Wood];

const pastEvents = [
  {
    title: 'Arta Gallery, April 2026',
    slides: [slides7, slides8],
  },
  
  {
    title: 'Thompson Gallery, December 2025',
    slides: [slides5, slides6],
  },
  {
    title: 'Casa De Bamba, July 2025',
    slides: [slides1, slides2],
  },
  
];

const PopupsPage = () => {

  const [slideIndexes, setSlideIndexes] = useState(
    pastEvents.map((event) => event.slides.map(() => 0))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndexes((prevIndexes) =>
        prevIndexes.map((eventIndexes, eventIndex) =>
          eventIndexes.map((currentSlideIndex, slideshowIndex) => {
            const currentSlides =
              pastEvents[eventIndex].slides[slideshowIndex];

            return (currentSlideIndex + 1) % currentSlides.length;
          })
        )
      );
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const goToPrevSlide = (eventIndex, slideshowIndex, totalSlides) => {
    setSlideIndexes((prevIndexes) =>
      prevIndexes.map((eventIndexes, eIndex) =>
        eventIndexes.map((currentSlideIndex, sIndex) => {
          if (eIndex === eventIndex && sIndex === slideshowIndex) {
            return (currentSlideIndex - 1 + totalSlides) % totalSlides;
          }

          return currentSlideIndex;
        })
      )
    );
  };

  const goToNextSlide = (eventIndex, slideshowIndex, totalSlides) => {
    setSlideIndexes((prevIndexes) =>
      prevIndexes.map((eventIndexes, eIndex) =>
        eventIndexes.map((currentSlideIndex, sIndex) => {
          if (eIndex === eventIndex && sIndex === slideshowIndex) {
            return (currentSlideIndex + 1) % totalSlides;
          }

          return currentSlideIndex;
        })
      )
    );
  };

  const goToSlide = (eventIndex, slideshowIndex, selectedIndex) => {
    setSlideIndexes((prevIndexes) =>
      prevIndexes.map((eventIndexes, eIndex) =>
        eventIndexes.map((currentSlideIndex, sIndex) => {
          if (eIndex === eventIndex && sIndex === slideshowIndex) {
            return selectedIndex;
          }

          return currentSlideIndex;
        })
      )
    );
  };

  return (
    <section className="popups-page">
      <div className="popups-overlay" />

      <h1 className="popups-title">Maplee Pop-Up Events</h1>

      {/* Upcoming Events */}
      <div className="upcoming-buttons">

        <div className="upcoming-card">
          <a
            href="https://docs.google.com/forms/d/1k4S5NQMP0at_ZJPbF2721WlSBu9ST9nSAJ8Trus4dlw/edit"
            className="upcoming-btn upcoming-btn-distillery"
            aria-label="Distillery pop-up event"
          />

          <div className="upcoming-card-text">
            <h3>Distillery District</h3>
            <p>May 16-18th</p>
          </div>
        </div>

        <div className="upcoming-card">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfqoxVkJICP-ygzbg-9GuNVmg4Fe5b_BrjJaYV7o7gafkmMpQ/viewform?usp=header"
            className="upcoming-btn upcoming-btn-toronto"
            aria-label="Toronto pop-up event"
          />

          <div className="upcoming-card-text">
            <h3>Toronto</h3>
            <p>May 30th, 31st & July 13th, 14th</p>
          </div>
        </div>

        <div className="upcoming-card">
          <a
            href="/montreal-pop-up"
            className="upcoming-btn upcoming-btn-montreal"
            aria-label="Montreal pop-up event"
          />

          <div className="upcoming-card-text">
            <h3>Montreal</h3>
            <p>Coming Soon!</p>
          </div>
        </div>
      </div>

      {/* Past Events */}
      <div className="popups-past">
        <h2>Past Events</h2>

        {pastEvents.map((event, eventIndex) => (
          <div className="popup-event-block" key={event.title}>
            <h3 className="popup-event-title">{event.title}</h3>

            <div className="popup-gallery">
              {event.slides.map((slides, slideshowIndex) => {
                const currentIndex =
                  slideIndexes[eventIndex]?.[slideshowIndex] || 0;

                return (
                  <div className="popup-slide-box" key={slideshowIndex}>
                    <button
                      className="popup-arrow left"
                      onClick={() =>
                        goToPrevSlide(eventIndex, slideshowIndex, slides.length)
                      }
                      aria-label="Previous slide"
                    >
                      &#10094;
                    </button>

                    <img
                      src={slides[currentIndex]}
                      alt={`${event.title} slide ${currentIndex + 1}`}
                      className="popup-slide-img"
                    />

                    <button
                      className="popup-arrow right"
                      onClick={() =>
                        goToNextSlide(eventIndex, slideshowIndex, slides.length)
                      }
                      aria-label="Next slide"
                    >
                      &#10095;
                    </button>

                    <div className="popup-slide-dots">
                      {slides.map((_, dotIndex) => (
                        <button
                          key={dotIndex}
                          className={`dot ${
                            currentIndex === dotIndex ? 'active' : ''
                          }`}
                          onClick={() =>
                            goToSlide(eventIndex, slideshowIndex, dotIndex)
                          }
                          aria-label={`Go to slide ${dotIndex + 1}`}
                        />
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PopupsPage;